import { createContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';

export interface CreateTermineFormContextValue {
  form: UseFormReturn<FormValues>;
  loading: boolean;
  onSubmit: () => void;
  isMobile: boolean;
  isDesktop: boolean;
}

export const CreateTermineFormContext =
  createContext<CreateTermineFormContextValue | null>(null);
